<template>
    <div class="container-fluid">
        <Breadcrumb title="PMTA Relays Deliverability" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        Percentage of relay deliveries to deliveries to all groups. All time, 24 hour, 2 hour. Calculation every 1 hour.
                    </div>
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group">
                                <label>Mail Service</label>
                                <treeselect v-model="filter.mailServiceId" placeholder="All Mail Services"
                                            :multiple="false"
                                            :options="mailServiceList"
                                            :load-options="loadMailServiceList"
                                            :auto-load-root-options="true"/>
                            </div>
                            <div class="form-group">
                                <label>Relay Group</label>
                                <treeselect v-model="filter.relayGroupId" placeholder="All Relays"
                                            :multiple="false"
                                            :options="relayGroupList"
                                            :load-options="loadRelayGroupList"
                                            :auto-load-root-options="true"/>
                            </div>
                            <input v-model="filter.smtpHost" type="text" class="form-control form-control-line"
                                   placeholder="Search by SMTP Host">
                        </div>
                        <div class="form-row">
                            <div class="col-2">
                                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light w-100"
                                        @click="getItems(page=1)">
                                    Get
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="report.length === 0">{{emptyMessage}}</div>
                            <div v-else>
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th @click="tableOrdering('pmtaRelay.id')">
                                                    <span role='button'>Relay ID</span>
                                                </th>
                                                <th @click="tableOrdering('pmtaRelay.smtpHost')">
                                                    <span role='button'>Host</span>
                                                </th>
                                                <th @click="tableOrdering('pmtaRelay.ip')">
                                                    <span role='button'>IP</span>
                                                </th>
                                                <th @click="tableOrdering('mailProvider.name')">
                                                    <span role='button'>MailService</span>
                                                </th>
                                                <th @click="tableOrdering('scoreAllTime')">
                                                    <span role='button'>Score All Time</span>
                                                </th>
                                                <th @click="tableOrdering('score24')">
                                                    <span role='button'>Score 24 hours</span>
                                                </th>
                                                <th @click="tableOrdering('score2')">
                                                    <span role='button'>Score 2 hours</span>
                                                </th>

                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(line, index) in report" :key="index">
                                                <td class="align-middle">{{line.pmtaRelay.id}}</td>
                                                <td class="align-middle">{{line.pmtaRelay.smtpHost}}</td>
                                                <td class="align-middle">{{line.pmtaRelay.ip}}</td>
                                                <td class="align-middle">{{line.mailProvider.name}}</td>
                                                <td class="align-middle">
                                                    <span v-tooltip.top="'All time'">{{line.scoreAllTime}}</span>
                                                </td>
                                                <td class="align-middle">
                                                    <span v-tooltip.top="'24 hours'">{{line.score24}}</span>
                                                </td>
                                                <td class="align-middle">
                                                    <span v-tooltip.top="'2 hours'">{{line.score2}}</span>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <paginate :click-handler="getItems"
                                              :container-class="'pagination justify-content-center'"
                                              :margin-pages="2"
                                              :next-class="'page-item'"
                                              :next-link-class="'page-link'"
                                              :next-text="'Next'"
                                              :page-class="'page-item'"
                                              :page-count="pageCount"
                                              :page-link-class="'page-link'"
                                              :page-range="3"
                                              :prev-class="'page-item'"
                                              :prev-link-class="'page-link'"
                                              :prev-text="'Prev'"
                                              v-if="pageCount > 1"
                                              v-model="page">
                                    </paginate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import Swal from 'sweetalert2'
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import ReportService from '../services/ReportService';
    import MailProviderService from '../services/MailProviderService';
    import PmtaRelayGroupService from '../services/PmtaRelayGroupService';
    import paginateMixin from '../mixins/paginate-mixin';

    export default {
        name: 'PmtaRelayDeliverabilityReport',
        components: {
            Treeselect,
            Breadcrumb,
            Preloader,
        },
        mixins: [paginateMixin],
        data() {
            return {
                emptyMessage: '',
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                report: [],
                relayGroupList: null,
                mailServiceList: null,
                filter: {
                    relayGroupId: null,
                    smtpHost: null,
                    mailServiceId: null
                },
                order: {
                    field: 'pmtaRelay.id',
                    direction: 'asc'
                },
                loading: false,
                isAdmin: false
            }
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
        },
        methods: {
            loadRelayGroupList({callback}) {
                PmtaRelayGroupService.getGroupSelect().then(response => {
                    this.relayGroupList = response.data['hydra:member'].map(group => {
                        return {id: group.id, label: group.name}
                    });
                    callback();
                });
            },
            loadMailServiceList({callback}) {
                MailProviderService.getProviderSelect().then(response => {
                    this.mailServiceList = response.data['hydra:member'].map(group => {
                        return {id: group.id, label: group.name}
                    });
                    callback();
                });
            },
            getItems: function (pageNum) {
                this.loading = true;
                ReportService.getPmtaRelayDeliverabilityReport(
                    pageNum,
                    this.perPage,
                    this.order,
                    this.filter
                ).then(response => {
                    this.report = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    if (this.totalItems === 0) {
                        this.emptyMessage = 'Nothing to show.'
                    } else {
                        this.emptyMessage = ''
                    }
                    this.loading = false;
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    });
                    this.loading = false;
                });
            },
            tableOrdering(field) {
                if (this.order.field === field) {
                    this.order.direction = (this.order.direction === 'asc') ? 'desc' : 'asc';
                } else {
                    this.order.field = field;
                    this.order.direction = 'asc';
                }
                this.getItems(this.page = 1);
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>
    tbody {
        font-size: 14px;
        font-family: Arial, serif;
    }
    td {
        padding: 0.1rem;
    }
</style>
